import { ActionType, createAction } from 'typesafe-actions'

import { ChecksConfig, IdIndexedInvestorChecks, InvestorCheck } from './types'

export const fetchAvailableChecksBegin = createAction(
  '/scenes/Dashboard/data/investorChecks/AVAILABLE_CHECKS_FETCH_BEGIN'
)

export const fetchAvailableChecksSuccess = createAction(
  '/scenes/Dashboard/data/investorChecks/AVAILABLE_CHECKS_FETCH_SUCCESS',
  (resolve) => (availableChecks: ChecksConfig[]) => resolve({ availableChecks })
)

export const fetchAvailableChecksFailure = createAction(
  '/scenes/Dashboard/data/investorChecks/AVAILABLE_CHECKS_FETCH_FAILURE',
  (resolve) => (error: string) => resolve({ error })
)

export const fetchInvestorChecksBegin = createAction(
  '/scenes/Dashboard/data/investorChecks/INVESTOR_CHECKS_FETCH_BEGIN'
)

export const fetchInvestorChecksSuccess = createAction(
  '/scenes/Dashboard/data/investorChecks/INVESTOR_CHECKS_FETCH_SUCCESS',
  (resolve) => (investorChecks: IdIndexedInvestorChecks) => resolve({ investorChecks })
)

export const fetchInvestorChecksFailure = createAction(
  '/scenes/Dashboard/data/investorChecks/INVESTOR_CHECKS_FETCH_FAILURE',
  (resolve) => (error: string) => resolve({ error })
)

export const createInvestorCheckBegin = createAction(
  '/scenes/Dashboard/data/investorChecks/CREATE_INVESTOR_CHECKS_BEGIN',
  (resolve) => (investorCheck: Partial<InvestorCheck>) =>
    resolve({
      investorCheck,
    })
)
export const createInvestorCheckSuccess = createAction(
  '/scenes/Dashboard/data/investorChecks/CREATE_INVESTOR_CHECKS_SUCCESS',
  (resolve) => (investorCheck: InvestorCheck) => resolve({ investorCheck })
)

export const createInvestorCheckFailure = createAction(
  '/scenes/Dashboard/data/investorChecks/CREATE_INVESTOR_CHECKS_FAILURE',
  (resolve) => (error: string) => resolve({ error })
)

export const updateInvestorCheckBegin = createAction(
  '/scenes/Dashboard/data/investorChecks/UPDATE_INVESTOR_CHECKS_BEGIN',
  (resolve) => (investorCheck: Partial<InvestorCheck>) =>
    resolve({
      investorCheck,
    })
)

export const updateInvestorCheckSuccess = createAction(
  '/scenes/Dashboard/data/investorChecks/UPDATE_INVESTOR_CHECKS_SUCCESS',
  (resolve) => (investorCheck: InvestorCheck) => resolve({ investorCheck })
)

export const updateInvestorCheckFailure = createAction(
  '/scenes/Dashboard/data/investorChecks/UPDATE_INVESTOR_CHECKS_FAILURE',
  (resolve) => (error: string) => resolve({ error })
)

export const deleteInvestorCheckBegin = createAction(
  '/scenes/Dashboard/data/investorChecks/DELETE_INVESTOR_CHECKS_BEGIN',
  (resolve) => (investorCheckId: InvestorCheck['id']) =>
    resolve({
      investorCheckId,
    })
)

export const deleteInvestorCheckSuccess = createAction(
  '/scenes/Dashboard/data/investorChecks/DELETE_INVESTOR_CHECKS_SUCCESS',
  (resolve) => (investorCheckId: number) => resolve({ investorCheckId })
)

export const deleteInvestorCheckFailure = createAction(
  '/scenes/Dashboard/data/investorChecks/DELETE_INVESTOR_CHECKS_FAILURE',
  (resolve) => (error: string) => resolve({ error })
)

export type InvestorCheckAction = ActionType<
  | typeof fetchAvailableChecksBegin
  | typeof fetchAvailableChecksFailure
  | typeof fetchAvailableChecksSuccess
  | typeof fetchInvestorChecksBegin
  | typeof fetchInvestorChecksSuccess
  | typeof fetchInvestorChecksFailure
  | typeof deleteInvestorCheckBegin
  | typeof deleteInvestorCheckSuccess
  | typeof deleteInvestorCheckFailure
  | typeof createInvestorCheckBegin
  | typeof createInvestorCheckSuccess
  | typeof createInvestorCheckFailure
  | typeof updateInvestorCheckBegin
  | typeof updateInvestorCheckSuccess
  | typeof updateInvestorCheckFailure
>
